import { onboardingMessagesDE } from '../../mocks/onBoarding/de';
import { onboardingMessagesEN } from '../../mocks/onBoarding/en';
import { onboardingMessagesFR } from '../../mocks/onBoarding/fr';

export enum OnboardingLanguage {
  DE = 'de-DE',
  FR = 'fr-FR',
  EN = 'en-GB',
}

export function useOnboardingMessages(language: string) {
  const messagesMap: Record<OnboardingLanguage, typeof onboardingMessagesEN> = {
    [OnboardingLanguage.DE]: onboardingMessagesDE,
    [OnboardingLanguage.FR]: onboardingMessagesFR,
    [OnboardingLanguage.EN]: onboardingMessagesEN,
  };

  if (Object.values(OnboardingLanguage).includes(language as OnboardingLanguage)) {
    return messagesMap[language as OnboardingLanguage];
  }

  return onboardingMessagesEN;
}
